import React, { useRef } from 'react'
import Slider from 'react-slick'
import './mobile.css'

const testimonials = [
  { image: '/assets/images/c1.jpg', quote: 'The astrologer provided incredibly accurate insights about my career.', name: 'Priya Sharma', profession: 'Mumbai' },
  { image: '/assets/images/c2.jpg', quote: 'Amazing kundli matching service.', name: 'Rahul Gupta', profession: 'Delhi' },
  { image: '/assets/images/c3.jpg', quote: 'Daily horoscope readings are spot-on!', name: 'Anjali Mehta', profession: 'Bangalore' },
  { image: '/assets/images/c4.jpg', quote: 'Authentic products in astroscope store.', name: 'Vikash Kumar', profession: 'Pune' },
  { image: '/assets/images/c5.jpg', quote: 'Great guidance and support.', name: 'Seema Rao', profession: 'Hyderabad' },
  { image: '/assets/images/c6.jpg', quote: 'Highly recommend their services.', name: 'Akash Jain', profession: 'Jaipur' },
]

const ClientTestimonials = () => {
  const sliderRef = useRef(null)

  const CustomPrevArrow = ({ onClick }) => (
    <button
      className="custom-carousel-btn custom-carousel-prev"
      onClick={onClick}
      aria-label="Previous testimonial"
    >
      <i className="fas fa-chevron-left"></i>
    </button>
  )

  const CustomNextArrow = ({ onClick }) => (
    <button
      className="custom-carousel-btn custom-carousel-next"
      onClick={onClick}
      aria-label="Next testimonial"
    >
      <i className="fas fa-chevron-right"></i>
    </button>
  )

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          centerMode: false,
          variableWidth: false,
        }
      }
    ]
  }

  // Desktop/Tablet card layout
  const renderDesktopCard = (testimonial, index) => (
    <div key={index} className="testimonial-desktop-slide">
      <div className="testimonial-card-desktop">
        <div className="testimonial-avatar-container">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="testimonial-avatar-img"
          />
        </div>
        <div className="testimonial-content">
          <p className="testimonial-quote">"{testimonial.quote}"</p>
          <div className="testimonial-author">
            <h4 className="testimonial-name">{testimonial.name}</h4>
            <span className="testimonial-location">{testimonial.profession}</span>
          </div>
        </div>
      </div>
    </div>
  )

  // Mobile card layout
  const renderMobileCard = (testimonial, index) => (
    <div key={index} className="testimonial-mobile-card">
      <div className="testimonial-mobile-content">
        <div className="testimonial-mobile-avatar">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="testimonial-mobile-img"
          />
        </div>
        <div className="testimonial-mobile-text">
          <p className="testimonial-mobile-quote">"{testimonial.quote}"</p>
          <div className="testimonial-mobile-author">
            <h5 className="testimonial-mobile-name">{testimonial.name}</h5>
            <span className="testimonial-mobile-location">{testimonial.profession}</span>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <section className="as_customer_wrapper ">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="as_heading as_heading_center">What My Client Say</h1>
          </div>
        </div>
        <div className="row">
          {/* Desktop and Tablet View - Carousel */}
          <div className="col-12">
            <div className="v3_blog_wrapper position-relative">
              <div className="row text-left d-none d-md-block">
                <Slider {...settings} ref={sliderRef}>
                  {testimonials.map((testimonial, index) => renderDesktopCard(testimonial, index))}
                </Slider>
              </div>
            </div>

            {/* Mobile View - Horizontal Scroll */}
            <div className="d-md-none">
              <div className="testimonial-mobile-wrapper">
                <div className="testimonial-mobile-scroll">
                  {testimonials.map((testimonial, index) => renderMobileCard(testimonial, index))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ClientTestimonials;
